import type { DisplayConfigItem } from '../../../platform/display-descriptors';

/**
 * 商品卡片排除：独立 architecture 行由 finalize 合并进镜像 tag；公共环境变量不进卡片/下单 displayConfig。
 * 确认预览仍走完整 buildDisplayDescriptors。
 */
export const MI_PRODUCT_CARD_EXCLUDED_DISPLAY_IDS = new Set(['architecture', 'model_network_segments']);

/** 动态环境变量行 common_env_0 … */
export const MI_PRODUCT_CARD_EXCLUDED_DISPLAY_ID_PREFIXES = ['common_env_'] as const;

function hasDisplayValue(item: DisplayConfigItem): boolean {
  return String(item.value ?? '').trim() !== '';
}

export function isMiProductCardDisplayId(id: string | undefined | null): boolean {
  const safeId = String(id ?? '').trim();
  if (!safeId) return true;
  if (MI_PRODUCT_CARD_EXCLUDED_DISPLAY_IDS.has(safeId)) return false;
  if (MI_PRODUCT_CARD_EXCLUDED_DISPLAY_ID_PREFIXES.some((prefix) => safeId.startsWith(prefix))) return false;
  return true;
}

export function filterMiProductCardDisplayConfig(items: DisplayConfigItem[]): DisplayConfigItem[] {
  return items.filter((item) => item && isMiProductCardDisplayId(item.id) && hasDisplayValue(item));
}
